interface Feature {
  text: string;
}

interface ServiceDetailProps {
  number: string;
  title: string;
  description: string;
  features: Feature[];
  icon: string;
  reverse?: boolean;
  bgClass?: string;
  imageUrl: string;
  imageAlt: string;
}

export default function ServiceDetail({
  number,
  title,
  description,
  features,
  icon,
  reverse = false,
  bgClass = 'bg-white',
  imageUrl,
  imageAlt,
}: ServiceDetailProps) {
  return (
    <section className={`${bgClass} py-24`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div
          className={`grid grid-cols-1 lg:grid-cols-2 gap-16 items-center ${
            reverse ? 'lg:flex-row-reverse' : ''
          }`}
        >
          <div className={reverse ? 'lg:order-2' : ''}>
            <div className="flex items-center gap-4 mb-6">
              <span className="text-5xl font-extrabold text-blue-600/20 leading-none">
                {number}
              </span>
              <div className="w-12 h-12 flex items-center justify-center bg-blue-600 rounded-xl">
                <i className={`${icon} text-white text-xl`} />
              </div>
            </div>
            <h2 className="text-3xl lg:text-4xl font-extrabold text-[#0F172A] mb-5">
              {title}
            </h2>
            <p className="text-slate-500 text-base leading-relaxed mb-8">
              {description}
            </p>
            <div>
              <p className="text-[#0F172A] text-sm font-semibold uppercase tracking-wider mb-4">
                Features Included
              </p>
              <ul className="space-y-3">
                {features.map((feat) => (
                  <li
                    key={feat.text}
                    className="flex items-center gap-3 text-slate-600 text-sm"
                  >
                    <div className="w-6 h-6 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0">
                      <i className="ri-check-line text-green-600 text-sm" />
                    </div>
                    {feat.text}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className={`${reverse ? 'lg:order-1' : ''}`}>
            <div className="rounded-2xl overflow-hidden border border-slate-100 w-full" style={{ height: '360px' }}>
              <img
                src={imageUrl}
                alt={imageAlt}
                title={title}
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
